(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('ft-bag')) customElements.define('ft-bag', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.addEventListener('submit', async event => {
        if (!event.target.matches('form')) return;
        if (event.submitter?.name === 'checkout') {
          if (this.checkoutVerified) { this.checkoutVerified=false; return; }
          event.preventDefault();
          if (this.busy || this.dataset.checkoutAllowed !== 'true') return;
          this.busy=true; const button=event.submitter; button.disabled=true;
          try {
            const url=new URL(this.dataset.url,location.origin);url.searchParams.set('section_id',this.dataset.section);
            const response=await fetch(url,{cache:'no-store',signal:this.abort.signal});if(!response.ok)throw new Error();
            const next=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('ft-bag');if(!next)throw new Error();
            if(next.dataset.checkoutAllowed !== 'true' || !next.querySelector('[name=checkout]')) {
              this.innerHTML=next.innerHTML;this.dataset.checkoutAllowed=next.dataset.checkoutAllowed;
              this.querySelector('[data-cart-error]')?.focus();return;
            }
            // Shopify still owns the final inventory validation and checkout/auth handoff.
            this.checkoutVerified=true;button.disabled=false;event.target.requestSubmit(button);
          } catch { const error=this.querySelector('[data-cart-error]');error.textContent=this.dataset.error;error.focus(); }
          finally { this.busy=false;button.disabled=this.dataset.checkoutAllowed !== 'true'; }
          return;
        }
        event.preventDefault(); if (this.busy) return; this.busy = true;
        const form=event.target, error=this.querySelector('[data-cart-error]'); error.textContent='';
        const buttons=[...form.querySelectorAll('button')], disabled=buttons.map(button=>button.disabled); buttons.forEach(button=>button.disabled=true);
        let feedback=this.dataset.error;
        try {
          for (const input of form.querySelectorAll('[data-key]')) {
            const response=await fetch(this.dataset.update,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:input.dataset.key,quantity:Number(input.value)})});
            const data=await response.json(); if (!response.ok) {feedback=typeof data.description==='string'?data.description:this.dataset.error;throw new Error();}
          }
          window.location.assign(this.dataset.url);
        } catch {error.textContent=feedback;error.focus();buttons.forEach((button,index)=>button.disabled=disabled[index]);this.busy=false;}
      },{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function setupLaunchInformation() {
    const panel=document.querySelector('.launch-information');
    if(!panel||panel.dataset.ready)return;
    panel.dataset.ready='true';
    panel.querySelector('[data-information-close]').addEventListener('click',()=>{panel.open=false;panel.querySelector('summary').focus({preventScroll:true});});
    panel.addEventListener('toggle',()=>{document.querySelector('main')?.toggleAttribute('inert',panel.open);document.querySelector('.site-header')?.toggleAttribute('inert',panel.open);});
    panel.addEventListener('keydown',event=>{
      if(!panel.open||event.key!=='Tab'||event.composedPath().some(node=>node.localName==='shopify-account'))return;
      const items=[...panel.querySelectorAll('summary,button,a[href],shopify-account:defined')].filter(el=>el.getClientRects().length),first=items[0],last=items.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
  }
  setupLaunchInformation();document.addEventListener('shopify:section:load',setupLaunchInformation);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const information = document.querySelector('.launch-information[open]');
    if (information) { information.open = false; information.querySelector('summary').focus(); }
  });
  document.addEventListener('click', (event) => {
    const information = document.querySelector('.launch-information[open]');
    if (information && !information.contains(event.target)) information.open = false;
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#PrivacyPolicy"]');
    if (!link) return;
    const policy = document.getElementById('PrivacyPolicy');
    if (policy) { policy.open = true; policy.querySelector('summary').focus(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch"] && !Shopify.designMode) return;
  try {
    
  function setupLookbooks() {
    document.querySelectorAll('.launch-lookbook:not([data-enhanced])').forEach(details => {
      if (!window.HTMLDialogElement?.prototype.showModal) return;
      details.dataset.enhanced = 'true';
      const trigger = details.querySelector('summary');
      const layer = details.querySelector('.launch-lookbook__layer');
      const dialog = document.createElement('dialog');
      dialog.className = 'lookbook-layer';
      dialog.id = details.id + '-dialog';
      dialog.setAttribute('aria-label', trigger.textContent.replace(/[\[\]]/g, ''));
      dialog.append(layer); details.after(dialog);
      const close = dialog.querySelector('[data-lookbook-close]'); close.hidden = false;
      trigger.setAttribute('aria-haspopup', 'dialog'); trigger.setAttribute('aria-controls', dialog.id); trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', event => {event.preventDefault();dialog.showModal();trigger.setAttribute('aria-expanded','true');close.focus({preventScroll:true});});
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {trigger.setAttribute('aria-expanded','false');trigger.focus({preventScroll:true});});
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('button,a[href]')];
        const first = controls[0], last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
        else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
      });
      if (location.hash === '#' + details.id || new URLSearchParams(location.search).has('lookbook')) {dialog.showModal();trigger.setAttribute('aria-expanded','true');close.focus({preventScroll:true});}
    });
  }
  setupLookbooks();
  document.addEventListener('shopify:section:load', setupLookbooks);
  document.addEventListener('shopify:block:select', (event) => {
    let details = event.target.closest('details');
    while (details) { details.open = true; details = details.parentElement.closest('details'); }
  });
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('.signup-form:not([data-klaviyo-form])')) return;
    const button = event.target.querySelector('button[type="submit"]');
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); setTimeout(() => { button.disabled = false; button.removeAttribute('aria-busy'); }, 10000); }
  });
  window.addEventListener('pageshow', () => { document.querySelectorAll('.signup-form:not([data-klaviyo-form]) button').forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); }); });

  } catch(e) { console.error(e); }
})();
})();
